import { useState, useEffect } from "react";
import { ITenantInfo } from "../interface/ITenant";
import React from "react";
import { Button } from "primereact/button";


export function useSetDeadline( deadlineString: any ) {
    const [deadline, setDeadline] = useState<string>("");

    useEffect(() => {
        if (deadlineString && deadlineString.length > 0) {
            const deadlineArr = deadlineString.split(":");
            setDeadline(deadlineArr[0] + ":" + deadlineArr[1]);
        }
    }, [deadlineString]);

    return deadline;
}


export function setFormatMessage(formattedMessage: string, has_MultipleCustomers: any, t: any, onGoToListOfCustomers: any, logout: any) {
    return <><div className="messageContent  w-9">
        <div className="center">{formattedMessage}</div>
    </div>
        <div className="flex justify-content-center flex-wrap mt-5 w-full">
            <div className="flex align-items-center justify-content-center w-9">
                {has_MultipleCustomers ?
                    <Button label={t("NewCart_GoToListOfCustomers")}
                        onClick={onGoToListOfCustomers}
                        className="p-button-raised p-button-default mr-2 mb-2 text-center w-full"
                    > </Button> :
                    <>
                        <Button onClick={logout} label={t('NewCart_Logout')} className='p-button-default w-full text-center' ></Button>
                    </>
                }
            </div>
        </div>
    </>;
}

export function NoAddressMessage(has_MultipleCustomers: any, t: any, onGoToListOfCustomers: any, logout: any) {
    return <div className="col-12">
        <div className="messageContent  w-9">
            <div>
                {t("NewCart_AddressNotFound")}

            </div>
        </div>
        <div className="flex justify-content-center flex-wrap mt-5">
            <div className="flex align-items-center justify-content-center w-9">
                {has_MultipleCustomers ?
                    <Button label={t("NewCart_GoToListOfCustomers")}
                        onClick={onGoToListOfCustomers}
                        className="p-button-raised p-button-default mr-2 mb-2 text-center w-full"
                    > </Button> :
                    <>
                        <Button onClick={logout} label={t('NewCart_Logout')} className='p-button-default w-full text-center' ></Button>
                    </>
                }
            </div>

        </div>


    </div>
}

